import { InjectionToken } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IVideosConfigDataModel } from '@app/shared/components/video-guide/models/video-input.model';

export let APP_CONFIG = new InjectionToken<string>('app.config');
export interface IAppConfig {
    activeConsoleLog: boolean;
    datePickerConfigFa: object;
    dateTimePickerConfigFa: object;
    datePickerConfig: object;
    dateTimePickerConfig: object;
    dateTimeFormat: string;
    dateFormat: string;
    apiEndpoint: string;
    hubEndpoint: string;
    imagePath: string;
    refreshTokenPath: string;
    recaptchaSiteKey: string;
    tablePageSize: number;
    cardPageSize: number;
    tablePageSizeOptions: number[];
    headersOptions: HttpHeaders;
    dropdownPageSize: number;
    fileUploadSize: number;
    allowFileExtentions: string[];
    tablePageSizeOption: number[];
    calcCommissionDebounceTime: number;
    notificationRefreshTime: number;
    pointPrecision: number;
    videosDataUrl: IVideosConfigDataModel;
}

export const AppConfig: IAppConfig = {
    activeConsoleLog: environment.activeConsoleLog,
    apiEndpoint: environment.apiEndpoint,
    hubEndpoint: environment.hubEndpoint,
    refreshTokenPath: environment.refreshTokenPath,
    imagePath: environment.imagePath,
    headersOptions: new HttpHeaders({ 'Content-Type': 'application/json' }),
    recaptchaSiteKey: environment.recaptchaSiteKey,
    datePickerConfigFa: environment.datePickerConfigFa,
    dateTimePickerConfigFa: environment.dateTimePickerConfigFa,
    datePickerConfig: environment.datePickerConfig,
    dateTimePickerConfig: environment.dateTimePickerConfig,
    dateTimeFormat: environment.dateTimeFormat,
    dateFormat: environment.dateFormat,
    calcCommissionDebounceTime: environment.calcCommissionDebounceTime,

    tablePageSize: environment.tablePageSize,
    cardPageSize: environment.cardPageSize,
    tablePageSizeOptions: environment.tablePageSizeOptions,
    dropdownPageSize: environment.dropdownPageSize,
    fileUploadSize: environment.fileUploadSize,
    allowFileExtentions: environment.allowFileExtentions,
    tablePageSizeOption: environment.tablePageSizeOption,

    notificationRefreshTime: environment.notificationRefreshTime,
    pointPrecision: environment.pointPrecision,
    videosDataUrl: environment.videosDataUrl
};
